import type { QueryTypeKey } from "../types/ragChatTypes";

export const QUERY_TYPE_BADGE: Record<
  string,
  { label: string; chipColor: "success" | "warning" | "secondary" | "primary" }
> = {
  instructions: { label: "Instructions", chipColor: "success" },
  diagnosis: { label: "Diagnosis", chipColor: "warning" },
  product_information: { label: "Product info", chipColor: "secondary" },
  finding_location: { label: "Finding location", chipColor: "primary" },
};

export function badgeForQueryType(q: QueryTypeKey) {
  if (!q) return null;
  return QUERY_TYPE_BADGE[q] ?? null;
}

/** Canonical assistant answer block order (see RagAssistantMessageCard). */
export const ASSISTANT_ANSWER_SECTION_ORDER = [
  "safety_alerts",
  "answer_and_diagrams",
  "options",
  "videos",
  "tables",
  "related_questions",
  "alternative_pdfs",
  "sources",
] as const;

export const ALERT_LEVEL_ORDER: Record<string, number> = {
  danger: 0,
  warning: 1,
  caution: 2,
  note: 3,
};

/** Visual tokens for safety notice cards (left-accent panel layout). */
export const ALERT_CARD_STYLES: Record<
  string,
  {
    accent: string;
    bg: string;
    labelColor: string;
    textColor: string;
    label: string;
  }
> = {
  danger: {
    accent: "#dc2626",
    bg: "#fef2f2",
    labelColor: "#dc2626",
    textColor: "#1f2937",
    label: "DANGER",
  },
  warning: {
    accent: "#ea580c",
    bg: "#fff7ed",
    labelColor: "#ea580c",
    textColor: "#1f2937",
    label: "WARNING",
  },
  caution: {
    accent: "#ca8a04",
    bg: "#fefce8",
    labelColor: "#ca8a04",
    textColor: "#1f2937",
    label: "CAUTION",
  },
  note: {
    accent: "#2563eb",
    bg: "#eff6ff",
    labelColor: "#2563eb",
    textColor: "#1f2937",
    label: "NOTE",
  },
};

export const ALERT_SEVERITY: Record<string, "error" | "warning" | "info"> = {
  danger: "error",
  warning: "warning",
  caution: "warning",
  note: "info",
};
